import { Permissions, security } from "Common/permissions";
import withPopupMessage from "Components/withPopupMessage";
import { connect } from "react-redux";
import { redoSelector, undoSelector } from "./constants";
import OntologicalModelComp from "./ontologicalModel";
import actionCreators from "./redux/actionCreators";
import { getDetailedPanelOpen, getDraftData, getFilterText, getHasChanges, getInProgress, getLayoutAlgorithm, getSaveInProgress, getShowNames } from "./redux/selectors";
const canEdit = security.isAllowed([Permissions.OntologicalModelEdit]);
const mapStateToProps = (state) => ({
    inProgress: getInProgress(state),
    saveInProgress: getSaveInProgress(state),
    layoutAlgorithm: getLayoutAlgorithm(state),
    hasChanges: getHasChanges(state),
    data: getDraftData(state),
    undoSelector,
    redoSelector,
    showNames: getShowNames(state),
    filterText: getFilterText(state),
    detailsPanelOpenByInteraction: getDetailedPanelOpen(state),
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: () => dispatch(actionCreators.getOntologicalModel()),
    onSaveData: (documentObjects, completed) => dispatch(actionCreators.saveOntologicalModel(documentObjects, completed)),
    onChangeModel: (data, updateSourceData) => dispatch(actionCreators.setOntologicalModel(data, updateSourceData)),
    onChangeDetailedPanelOpen: (open) => dispatch(actionCreators.setDetailedPanelOpen(open)),
    onSetLayoutAlgorithm: (layoutAlgorithm) => dispatch(actionCreators.setLayoutAlgorithm(layoutAlgorithm))
});
export default connect(mapStateToProps, mapDispatchToProps)(withPopupMessage(OntologicalModelComp));
